import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class Menu extends Component {
    render() {
        return (
            <div className="menu">
                <section className="banner" role="banner">

                    <header id="header">
                        <div className="header-content clearfix"> <Link to="/"></Link>
                            <nav className="navigation" role="navigation">
                                <ul className="primary-nav">

                                    <li>< Link to="/">About me</Link></li>
                                    <li>< Link to="graphic">Graphic</Link></li>
                                    <li>< Link to="web">Web</Link></li>
                                    <li><Link to="contact">Contact</Link></li>

                                </ul>
                            </nav>
                            <a href="" className="nav-toggle">Menu<span></span></a> </div>
                    </header>

                </section>



                <section id="banner" className="banner no-padding">
                    <div className="container-fluid">
                        <div className="row no-gutter">
                            <div className="flexslider">
                                <ul className="slides">
                                    <li>
                                        <div className="col-md-12">
                                            <blockquote>
                                                <h1>Hello! I'm On Yong Wai Sze</h1>
                                                <p>Web Designer, Graphic Designer, Front-end Developer</p>
                                            </blockquote>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/page/menu/Menu.js